import { useMediaQuery } from 'usehooks-ts';

export const useLgScreen = () => {
  return useMediaQuery('(min-width: 992px)');
};
